import FormElementRenderer from './form.el';
import * as CONST from '../const';
const ELEMENT_ID = 'checkbox_digital';
class FormElementDigitalRenderer extends FormElementRenderer {
    render(cont, index) {
        const inDigital = 'digital', hidden = '', inRolled = '', el = document.createElement('div');
        ['text-center', CONST.OPT_CLASS_OPTION_WIDE, inDigital, inRolled, hidden].forEach(name => name && el.classList.add(name));
        el.id = `option_digital`;
        el.dataset.name = 'digital';
        el.innerHTML = `
      <span>Цифровой макет</span><br/>
      <div class="input-checkbox">
        <input  id="${ELEMENT_ID}" type="checkbox" name="digital"/>
        <label for="${ELEMENT_ID}" tabindex="${index}"></label>
       </div>`;
        this.appendSwitchEl(el, cont);
    }
    appendSwitchEl(el, cont) {
        cont.appendChild(el);
        const switchEl = cont.querySelector(`#${ELEMENT_ID}`);
        if (switchEl) {
            switchEl.addEventListener('change', (e) => this.onDigitalChange(e));
        }
    }
    onDigitalChange(e) {
        if (e.target) {
            let el = e.target;
            this.owner.onDigitalChange(el.checked);
        }
    }
}
export default FormElementDigitalRenderer;
